

import { Newsletter } from "../components/newsletter";
import { Partners } from "../components/partners";
import { ProductsSection } from "../components/products";

function Products() {
  return (
    <>
      <ProductsSection />
      <Partners />
      <Newsletter />
    </>
  );
}

export default Products;